<template>
  <div class="bg" v-if="ready">
      <img style="width: 100%;" src="@assets/img/at.png" alt="" srcset="">
      <div class="innerBox">
        <div class="title">一、答题日期</div>
        <div class="time">{{resdata.time}}</div>
        <div class="title">二、竞赛规则</div>
        <div class="time">
          （1）挑战答题每人{{resdata.count}}题，共{{resdata.point}}分，答题类型为单选题，试题从题库中随机抽取。<br/>
          （2）挑战答题有总时间限制， 每人每天可答题{{resdata.Ccount}}次 ，答错立即结束答题，全部答对奖励积分。
        </div>
        <van-button style="margin-top: 0.9rem" type="danger" block round @click="todati" >开始答题</van-button>
        <img class="foot" src="@/assets/img/footer.png" alt="" srcset="">
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import { getChallDeatil,challAnserer} from "@api/answer";
Vue.use(Button);

export default {
  data(){
    return {
      ready: false,
      resdata:{}
    }
  },
  created(){
    this.getdate();
  },
  methods:{
    getdate(){
      getChallDeatil().then(res=>{
        console.log(res);
        this.ready = true;
        this.resdata = res.data;
      })
    },
    todati(){
      if(this.resdata.is == 1 ){
        if(this.resdata.tis  ==1){
          challAnserer().then(res=>{
            sessionStorage.setItem('answerData',JSON.stringify(res.data))
            this.$router.push({ path: "/answer/tzDati" });
          })
        }else{
          this.$dialog.error('今日已挑战成功，明日在来吧！')
        }
        
      }else{
        this.$dialog.error('答题次数已经用完')
      }
    }
  }
  
}
</script>

<style scoped>
  .bg{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: url('~@assets/img/bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .innerBox{
    margin: 3%;
    background: #FDF9EE;
    border-radius: 0.2rem;
    position: absolute;
    bottom: 0;
    width: 94%;
    top: 2.2rem;
    right: 0;
    left: 0;
    padding: 0.34rem;
    color: #202020;
  }
  .title{
    font-size: 0.3rem;
    line-height: 0.5rem;
  }
  .time{
    font-size: 0.3rem;
    line-height: 0.5rem;
    padding: 0.1rem 0;
  }
  .foot{
    display: block;
    width: 80%;
    position: absolute;
    left: 10%;
    bottom: 0.3rem;
  }
</style>